var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", {
    ref: "FileValidationObserver",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ passes }) {
          return [
            _c("div", { staticClass: "file-upload__container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col",
                    class: _vm.isProvisionalRemedyArea ? "col-sm-3" : "col-sm-4"
                  },
                  [
                    _c("span", { staticClass: "file-upload__label" }, [
                      _vm._v("Nombre del Documento:")
                    ]),
                    _c("validation-provider", {
                      staticClass: "w-100",
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El nombre del documento es requerido.",
                                    error: errors[0],
                                    maxlength: "50"
                                  },
                                  model: {
                                    value: _vm.model.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "name", $$v)
                                    },
                                    expression: "model.name"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col",
                    class: _vm.isProvisionalRemedyArea ? "col-sm-3" : "col-sm-4"
                  },
                  [
                    _c("validation-provider", {
                      staticClass: "w-100",
                      attrs: { name: "Documento", rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "file-upload__label" },
                                  [_vm._v("Archivo:")]
                                ),
                                _c("custom-file-input", {
                                  attrs: {
                                    accept: ".pdf",
                                    "custom-error-msg":
                                      "El documento es requerido.",
                                    "display-style": "normal",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.model.file,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "file", $$v)
                                    },
                                    expression: "model.file"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm.isProvisionalRemedyArea
                  ? _c(
                      "div",
                      { staticClass: "col col-sm-2 d-flex" },
                      [
                        _c("check-box", {
                          staticClass: "align-self-center mt-3",
                          attrs: { text: "Añadir Evaluador" },
                          model: {
                            value: _vm.model.canAddEvaluator,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "canAddEvaluator", $$v)
                            },
                            expression: "model.canAddEvaluator"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.model.canAddEvaluator
                  ? _c(
                      "div",
                      { staticClass: "col col-sm-4" },
                      [
                        _c("span", { staticClass: "file-upload__label" }, [
                          _vm._v("Nombre del Evaluador:")
                        ]),
                        _c("validation-provider", {
                          staticClass: "w-100",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El nombre del evaluador es requerido.",
                                        error: errors[0],
                                        maxlength: "50"
                                      },
                                      model: {
                                        value: _vm.model.evaluatorName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "evaluatorName",
                                            $$v
                                          )
                                        },
                                        expression: "model.evaluatorName"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.model.canAddEvaluator
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col col-sm-4 d-flex align-items-end justify-content-end"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "action-button",
                              {
                                staticClass: "action-button",
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant: "outline-danger"
                                },
                                on: { click: _vm.cancel }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                staticClass: "action-button",
                                attrs: {
                                  i: _vm.id
                                    ? "fas fa-save"
                                    : "fas fa-file-plus",
                                  variant: "success"
                                },
                                on: {
                                  click: function($event) {
                                    return passes(_vm.upload)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.id ? "Guardar" : "Añadir") +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm.model.canAddEvaluator
                ? _c("div", { staticClass: "row mt-4" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex align-items-end justify-content-end"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "action-button",
                              {
                                staticClass: "action-button",
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant: "outline-danger"
                                },
                                on: { click: _vm.cancel }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                staticClass: "action-button",
                                attrs: {
                                  i: _vm.id
                                    ? "fas fa-save"
                                    : "fas fa-file-plus",
                                  variant: "success"
                                },
                                on: {
                                  click: function($event) {
                                    return passes(_vm.upload)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.id ? "Guardar" : "Añadir") +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }